import { Link } from 'react-router-dom';

const MARK_TAGS = {
  bold: 'strong',
  italic: 'em',
  underline: 'u',
  strikethrough: 's',
  superscript: 'sup',
  subscript: 'sub',
};

// Defence in depth (spec section 57): the importer already sanitises links.
export function safeHref(href) {
  if (typeof href !== 'string') return null;
  const h = href.trim();
  if (h.startsWith('#') || (h.startsWith('/') && !h.startsWith('//'))) return h;
  return /^(https?:|mailto:|tel:)/i.test(h) ? h : null;
}

function TextNode({ node }) {
  let el = node.text;
  for (const mark of node.marks || []) {
    const Tag = MARK_TAGS[mark];
    if (Tag) el = <Tag>{el}</Tag>;
  }
  return el;
}

function LinkNode({ node }) {
  const href = safeHref(node.href);
  const children = <Inlines nodes={node.children} />;
  if (!href) return children;
  if (href.startsWith('/')) return <Link to={href}>{children}</Link>;
  const external = /^https?:/i.test(href);
  return (
    <a href={href} {...(external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}>
      {children}
    </a>
  );
}

export function Inlines({ nodes }) {
  if (!Array.isArray(nodes)) return null;
  return nodes.map((node, i) => {
    if (node?.type === 'text') return <TextNode key={i} node={node} />;
    if (node?.type === 'link') return <LinkNode key={i} node={node} />;
    return null;
  });
}

export function plainText(nodes) {
  if (!Array.isArray(nodes)) return '';
  return nodes.map((n) => (n.type === 'link' ? plainText(n.children) : n.text || '')).join('');
}
